import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgExternalLinkOutlined = ({ size, title = 'ExternalLinkOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M6 18L18 6M6.923 6H18v11.077"
        />
    </svg>
);

export default withIcon(SvgExternalLinkOutlined);
